/* eslint-disable @typescript-eslint/no-explicit-any */
import { httpApi } from '@app/api/http.api';
interface StatusObject {
  status: boolean;
}
// POST: Add a new retail price audit report
export const countriesUpdate = (id: string, data: StatusObject): Promise<undefined> =>
  httpApi.put<undefined>(`countries/${id}/countriesUpdate `, data).then(({ data }) => data);
